import React from 'react';
import type { HeadFC, PageProps } from 'gatsby';
import { graphql } from 'gatsby';
import { GatsbyImage, getImage, IGatsbyImageData, ImageDataLike } from 'gatsby-plugin-image';

import {
  Seo,
  Layout,
  PostBox,
  Masonry,
  ZoomImage,
} from '../components';

const ModelingPage = ({ data }: PageProps<DataProps>) => (
  <Layout>
    <PostBox title="Modeling">
      <Masonry>
        {data.allFile.nodes.map(({ name, ...imgData }) => {
          const image = getImage(imgData) as IGatsbyImageData;
          return (
            <ZoomImage key={name} name={name}>
              <GatsbyImage
                image={image}
                alt={ name }
                style={{
                  position: 'static',
                  maxHeight: '100%',
                  maxWidth: '100%',
                  height: '100%',
                  width: '100%',
                }}
                imgStyle={{
                  objectFit: 'scale-down',
                }}
              />
            </ZoomImage>
          );
        })}
      </Masonry>
    </PostBox>
  </Layout>
);

export default ModelingPage;

export const Head: HeadFC = () => (<Seo title="Modeling" description="Modeling and cosplay photo shoots" />);

export const query = graphql`
{
  allFile(
    filter: {extension: {regex: "/(jpg)|(png)|(jpeg)/"}, relativePath: {regex: "/^modeling\\//"}}
  ) {
    nodes {
      name
      childImageSharp {
        gatsbyImageData
      }
    }
  }
}
`

type DataProps = {
  allFile: {
    nodes: (ImageDataLike & { name: string, relativePath: string })[],
  },
}
